import React, { Component, ReactNode } from "react";
import { logger } from "@/client/services/logger/logger";

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}
interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    logger.error(`ErrorBoundary caught an error: ${error.message}`, error, "ErrorBoundary");

    logger.error(
      "Component stack trace",
      new Error(errorInfo.componentStack as string | undefined),
      "ErrorBoundary",
    );
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return this.props.fallback || <h1>une Erreur est survenue</h1>;
    }

    return this.props.children;
  }
}
